export default "__VITE_ASSET__UwOKU8jh__"